import ContentBlock from './ContentBlock';
import CtaBlock from './CtaBlock';
import CtaButtons from './CtaButtons';
import DocsMenu from './DocsMenu';
import DocsSubmenu from './DocsSubmenu';
import FeaturesBlock from './FeaturesBlock';
import Footer from './Footer';
import Header from './Header';
import HeroBlock from './HeroBlock';
import Menu from './Menu';
import Social from './Social';
import Layout from './Layout';

export {
    ContentBlock,
    CtaBlock,
    CtaButtons,
    DocsMenu,
    DocsSubmenu,
    FeaturesBlock,
    Footer,
    Header,
    HeroBlock,
    Menu,
    Social,
    Layout
};

export default {
    ContentBlock,
    CtaBlock,
    CtaButtons,
    DocsMenu,
    DocsSubmenu,
    FeaturesBlock,
    Footer,
    Header,
    HeroBlock,
    Menu,
    Social,
    Layout
};
